import type { ReactNode } from "react";
import classNames from "classnames";

export interface StatusTextProps {
  children: ReactNode;
  textTransform?: "uppercase" | "capitalize" | "lowercase" | "normal-case";
  variant?: "success" | "warning" | "danger" | "default" | "info";
}

const fontColors = {
  success: "text-v2-success",
  warning: "text-v2-warning-900",
  danger: "text-v2-danger",
  default: "text-dark",
  info: "text-v2-info",
};

export const StatusText = ({
  children,
  variant = "default",
  textTransform,
}: StatusTextProps) => {
  const fontStyles = fontColors[variant] || fontColors.default;

  return (
    <span className={classNames("text-sm", fontStyles, textTransform)}>
      {children}
    </span>
  );
};
